import { Pipe, PipeTransform } from '@angular/core';
import { slugifyString2 } from '@app/_core/utility';

@Pipe({
    name: 'slugify2',
    standalone: false
})
export class SlugifyPipe2 implements PipeTransform {
  transform(str: string): string {
    return slugifyString2(str);
  }
}
